import React from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import AgendaItemCard from "./AgendaItemCard";

export default function AgendaList({
  items,
  resolveItemColor,
  onSelectItem,
}) {
  return (
    <Card sx={{ borderRadius: 4, height: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Day Items
        </Typography>

        {(items || []).length === 0 ? (
          <Typography color="text.secondary">
            No agenda items scheduled for the selected day.
          </Typography>
        ) : (
          <Stack spacing={1.5}>
            {items.map((item) => (
              <AgendaItemCard
                key={item.id}
                item={item}
                color={resolveItemColor(item)}
                onClick={onSelectItem}
              />
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
